import React, { Dispatch, FC, SetStateAction } from "react";
import { useOnChangeChildDispatch } from "utils/OnChange";
import { ThemeBuilderSection } from "../WidgetThemeBuilder/ThemeBuilderSection";
import { WidgetMarginPicker } from "../WidgetThemeBuilder/WidgetMarginPicker";
import { SearchWidgetLinkBlockTheme } from "./SearchWidgetTypes";
import { SearchWidgetTextThemeBuilder } from "./TextThemeBuilder";

export interface SearchWidgetLinkBlockThemeBuilderProps {
    readonly label: string;
    readonly theme: SearchWidgetLinkBlockTheme | undefined;
    readonly defaultTheme: SearchWidgetLinkBlockTheme | undefined;
    readonly onChange: Dispatch<SetStateAction<SearchWidgetLinkBlockTheme>>;
}

const EMPTY_THEME: SearchWidgetLinkBlockTheme = {};

const SearchWidgetLinkBlockThemeBuilderInner: FC<SearchWidgetLinkBlockThemeBuilderProps> = props => {
    const theme: SearchWidgetLinkBlockTheme = props.theme ?? EMPTY_THEME;
    const defaultTheme: SearchWidgetLinkBlockTheme = props.defaultTheme ?? EMPTY_THEME;

    const { onChange } = props;

    const onTextChange = useOnChangeChildDispatch("text", onChange);
    const handleDefaultTextChange = useOnChangeChildDispatch("default", onTextChange);
    const handleMarginChange = useOnChangeChildDispatch("margin", onChange);
    const handlePaddingChange = useOnChangeChildDispatch("padding", onChange);

    return (
        <ThemeBuilderSection heading={props.label} className="widget-text-theme-builder">
            <SearchWidgetTextThemeBuilder key="text" theme={theme.text?.default} defaultTheme={defaultTheme.text?.default} onChange={handleDefaultTextChange} />
            <WidgetMarginPicker key="margins" theme={theme.margin} defaultTheme={defaultTheme.margin} onChange={handleMarginChange} />
            <WidgetMarginPicker key="paddings" label="Padding" theme={theme.padding} defaultTheme={defaultTheme.padding} onChange={handlePaddingChange} />
        </ThemeBuilderSection>
    );
};

export const SearchWidgetLinkBlockThemeBuilder = React.memo(SearchWidgetLinkBlockThemeBuilderInner);
